import { CursorClasses_CursorParent_$ctor_Z207A3CFB } from "../Types/Cursor.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const Cursor = CursorClasses_CursorParent_$ctor_Z207A3CFB(new Property_CssProperty(91));

